import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { compareAsc, format } from 'date-fns'
import Modal from "react-bootstrap/Modal";
import moment from "moment";

function EmpAttendanceCom() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');
    const [searchemail, setSearchemail] = useState('');
    const [dept, setDept] = useState('');
    const [empatt, setEmpatt] = useState([]);
    const [modalstatus, setModalstatus] = useState(false);
    const [modalcomment, setModalcomment] = useState(false);
    const [remark, setRemark] = useState('')
    const [id_att, setId_att] = useState('');
    const [err, setErr] = useState('');
    const [msg, setSmg] = useState('');
    const [att_remark, setAtt_remark] = useState('')
    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions

    useEffect(() => {
        getHrAttendance()
    }, [])
    const getHrAttendance = async (pagenumber) => {
        const response = await fetch(SERVER_URL + `api/leave/all-leave-history?query=${searchemail}&page=${pagenumber}&department=${dept}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                // console.log('data.data')
                // console.log(data.data)
                // console.log('data.data')
                if (data.status == true) {
                    setEmpatt(data.data)
                }
            });
    }
    const leave_type_arr = ["", "Earned Leave", "Casual Leave", "Sick Leave", "Leave Without Pay"];
    const handleRelect = (id) => {
        // alert(id)
    }
    const handleApproved = (id, empId, fromDate, toDate) => {
        fetch(SERVER_URL + `api/leave/leave-update-status`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id,
                    statusValue: 1,
                    empId: empId,
                    formDate: fromDate,
                    toDate: toDate,
                    requestType: 3,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getHrAttendance()
                }
            });
    }
    const handleReject = (id) => {
        setSmg('');
        setId_att(id)
        setModalstatus(true)
    }
    const handleClose = () => {
        setModalcomment(false)
        setAtt_remark('')
        setModalstatus(false)
        setRemark('');
        setId_att('')
    }

    const handleRejectUpdate = () => {
        fetch(SERVER_URL + `api/leave/leave-rejected`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id_att,
                    statusValue: 3,
                    remark: remark,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setErr('green');
                    setSmg('Attendance successfully Reject!')
                    setTimeout(function () {
                        getHrAttendance()
                        handleClose()
                    }, 1000);
                }
            });
    }
    const handleMSG = (id) => {
        const response = fetch(SERVER_URL + `api/leave/get-leave-remark`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setAtt_remark(data.data.remark)
                }
            })
        setModalcomment(true)

    }
    const dateConverter = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result > 1 ? result + ' Days' : result + 'Day'
    }
    const handleRegularise = (id, userId, reg_date, reg_start_time, reg_end_time, att_id) => {
        //         alert('ok ok'+id+' user id'+userId+'date:'+reg_date+'s_time'+reg_start_time+'end_time:'+reg_end_time)
        //   return false;
        const response = fetch(SERVER_URL + `api/attendance/timesheet-approved`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    RequestID: id,
                    RequestUserID: userId,
                    action: 1,
                    requestType: 2,
                    attId: att_id > 0 ? att_id : '',
                    attUserID: userId,
                    startTime: reg_start_time,
                    endTime: reg_end_time,
                    attDate: reg_date
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getHrAttendance()
                }
            })

    }
    return (
        <>
            <Modal show={modalcomment} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-2">
                        <textarea value={att_remark} className="form-control" placeholder="" >{att_remark}</textarea>
                    </div>
                </div>
            </Modal>
            <Modal show={modalstatus} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-2">
                        <textarea value={remark} onChange={(e) => { setRemark(e.target.value) }} className="form-control" placeholder="" >{remark}</textarea>
                    </div>
                    <div className="modalfooter">
                        <span style={{ color: err }}>{msg}</span>
                        <button type="button" onClick={handleClose} className="btn_6 float-end ml10" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" onClick={handleRejectUpdate} className="btn_5 float-end">Add</button>
                    </div>
                </div>

            </Modal>
            <div className="page-header">
                <h1>
                    {/* <Link className="btn_5 mr10 float-end" to='/addemployee'>Add Employee</Link> */}
                    Leave Approval</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                     <li>
						<Link to="/dashboard">Dashboard </Link>
					</li>
                    <li className="current">
                        <span>/</span> Leave Approval
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                {/* <div className="dash_white_box2 mb20 p20">
                    <div className="dash_white_box_ttl">Search</div>
                    <div className="row mb10">
                        <div className="col-lg-3 col-md-6 pr07">
                            <label className="form-label">Employee Name / Code</label>
                            <input type="text" className="form-control" autoComplete='none' placeholder='Search by name' />
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <label className="form-label">Department</label>
                            <div className="form-input">
                                <select className="form-select">
                                    <option>Select Department </option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <label className="form-label"> Designation</label>
                            <div className="form-input">
                                <select className="form-select">
                                    <option>Select Designation </option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 pr07">
                            <label className="h49"></label>
                            <button className="btn_5">Search</button>
                        </div>
                    </div>
                </div> */}
                <div className="row mb30">
                    <div className="col-md-12">
                        <table className="table_style_1">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>Department </th>
                                    <th>Leave Type	</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th style={{ width: "170px" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    empatt.map((item, ind) => {
                                        return <tr key={ind + 1}>
                                            <td>{item.name ? item.name : ''} ({item.user_code})</td>
                                            <td>{item.department_name}</td>
                                            <td>
                                                {item.request_type == 2 && <span className="avatar_icon">Rg</span>}
                                                {item.request_type != 2 && <span className="avatar_icon">{leave_type_arr[item.leave_type] ? leave_type_arr[item.leave_type].match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>}

                                            </td>
                                            <td>
                                               
                                                {item.request_type != 2 && <span>
                                                    {moment(item.from_date).format('DD MMM, yyyy')} - {moment(item.to_date).format('DD MMM, yyyy')}-({dateConverter(new Date(item?.to_date), new Date(item?.from_date))})
                                                </span>
                                                }
                                            </td>
                                            <td>
                                                {(function () {
                                                    if (item.status == 1) {
                                                        <span className="badge bg-primary">Approved</span>
                                                    }
                                                    else if (item.status == 3) {
                                                        return <span className="badge bg-danger">Rejected</span>
                                                    }
                                                    else {
                                                        return <span className="badge bg-success">Pending</span>
                                                    }
                                                })()}
                                            </td>
                                            <td style={{ width: '150px' }}> 
                                                {(
                                                    function () {
                                                        if (item.status == 0 && item.request_type == 2) {
                                                            return hr_permission?.includes('29') && (<button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button>)
                                                        }
                                                        if (item.status == 1 && item.request_type == 2) {
                                                            return '';
                                                        }
                                                        // if (item.status == 1) {
                                                        //     return <span className="btn_8" onClick={(e) => { handleMSG(item.id) }}>Reason</span>
                                                        // }
                                                         else if (item?.status == 3) {

                                                            return <><button className="btn_8 mr05 btniconi" onClick={(e) => { handleMSG(item.id) }}><i className='icon icon-bubbles'></i></button><button className="btn_7 mr03 btniconi" onClick={(e) => { handleApproved(item.id) }}><i className='icon icon-check'></i></button></>
                                                        } else {
                                                            if (item.request_type != 3) {
                                                                   return <><button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button></>
                                                              
                                                            }
                                                            if (item.request_type !== 2 || item.request_type !== 1) {
                                                               
                                                                if (hr_permission.includes('29') && hr_permission.includes('30')) {
                                                                    return <>
                                                                    { hr_permission?.includes('29') && (<button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button>)}

                                                                    {hr_permission?.includes('30') && (<button className="btn_8" onClick={(e) => { handleReject(item.id) }} >Reject</button>)}
                                                                    </>
                                                                }
                                                                if (hr_permission.includes('29') && !hr_permission.includes('30')) {
                                                                    return <>
                                                                        { hr_permission?.includes('29') && (<button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button>)}
                                                                    </>
                                                                }
                                                                if (!hr_permission.includes('29') && hr_permission.includes('30')) {
                                                                    return <>
                                                                        {hr_permission?.includes('30') && (<button className="btn_8" onClick={(e) => { handleReject(item.id) }} >Reject</button>)}
                                                                    </>
                                                                }
                                                              

                                                            }

                                                        }
                                                    })()}
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                            <tfoot>

                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmpAttendanceCom
